import { render, staticRenderFns } from "./ShowTests.vue?vue&type=template&id=04ed9edd&"
import script from "./ShowTests.vue?vue&type=script&lang=js&"
export * from "./ShowTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports